<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Logo from '@/app/assets/images/logo.svg';

const { locale } = useI18n();
</script>

<template>
  <a :href="`/${locale}/insurance-renewal`" data-test="main-logo">
    <img :src="Logo" alt="logo qic">
  </a>
</template>
